export default __webpack_public_path__ + "static/media/Agenda_title_rollover.8d77a1de.svg";